import React, { useState } from 'react';
import '../../css/ArchiveLibrary.css';

const ArchiveModal = ({ tasks, boardLabels, onArchive, onClose }) => {
    const [mode, setMode] = useState('single');
    const [selectedLabel, setSelectedLabel] = useState(boardLabels[0] || '');
    const [groupName, setGroupName] = useState('');
    const [archiving, setArchiving] = useState(false);

    const handleSubmit = async () => {
        setArchiving(true);
        const taskIds = tasks.map(t => t.id);
        if (mode === 'single') {
            await onArchive(taskIds, 'single');
        } else if (mode === 'label') {
            await onArchive(taskIds, 'label', selectedLabel);
        } else if (mode === 'custom') {
            await onArchive(taskIds, 'custom', groupName.trim());
        }
        setArchiving(false);
    };

    const canSubmit = mode === 'single'
        || (mode === 'label' && selectedLabel)
        || (mode === 'custom' && groupName.trim());

    return (
        <div className="ArchiveModal__overlay" onClick={onClose}>
            <div className="ArchiveModal" onClick={(e) => e.stopPropagation()}>
                <div className="ArchiveModal__header">
                    <h3 className="ArchiveModal__title">
                        <i className="fas fa-archive" /> Archive {tasks.length === 1 ? 'Task' : `${tasks.length} Tasks`}
                    </h3>
                    <button className="ArchiveModal__close" onClick={onClose}>&times;</button>
                </div>

                <div className="ArchiveModal__body">
                    <div className="ArchiveModal__modes">
                        <label className="ArchiveModal__mode-option">
                            <input
                                type="radio"
                                name="archiveMode"
                                value="single"
                                checked={mode === 'single'}
                                onChange={() => setMode('single')}
                            />
                            <div className="ArchiveModal__mode-info">
                                <span className="ArchiveModal__mode-label">Archive as singles</span>
                                <span className="ArchiveModal__mode-desc">Tasks go to the singles pool</span>
                            </div>
                        </label>

                        <label className="ArchiveModal__mode-option">
                            <input
                                type="radio"
                                name="archiveMode"
                                value="label"
                                checked={mode === 'label'}
                                onChange={() => setMode('label')}
                            />
                            <div className="ArchiveModal__mode-info">
                                <span className="ArchiveModal__mode-label">Group by label</span>
                                <span className="ArchiveModal__mode-desc">Group under an existing label</span>
                            </div>
                        </label>

                        {mode === 'label' && (
                            <select
                                className="ArchiveModal__select"
                                value={selectedLabel}
                                onChange={(e) => setSelectedLabel(e.target.value)}
                            >
                                {boardLabels.length === 0 && <option value="">No labels available</option>}
                                {boardLabels.map(l => (
                                    <option key={l} value={l}>{l}</option>
                                ))}
                            </select>
                        )}

                        <label className="ArchiveModal__mode-option">
                            <input
                                type="radio"
                                name="archiveMode"
                                value="custom"
                                checked={mode === 'custom'}
                                onChange={() => setMode('custom')}
                            />
                            <div className="ArchiveModal__mode-info">
                                <span className="ArchiveModal__mode-label">Custom group</span>
                                <span className="ArchiveModal__mode-desc">Create a named archive group</span>
                            </div>
                        </label>

                        {mode === 'custom' && (
                            <input
                                className="ArchiveModal__input"
                                type="text"
                                value={groupName}
                                onChange={(e) => setGroupName(e.target.value)}
                                placeholder="Group name..."
                                autoFocus
                            />
                        )}
                    </div>
                </div>

                <div className="ArchiveModal__actions">
                    <button className="ArchiveModal__cancel" onClick={onClose} disabled={archiving}>Cancel</button>
                    <button
                        className="ArchiveModal__submit"
                        onClick={handleSubmit}
                        disabled={!canSubmit || archiving}
                    >
                        {archiving ? 'Archiving...' : 'Archive'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ArchiveModal;
